module.exports = __webpack_public_path__ + "static/media/img3.93ef704a.jpg";